module.exports = __webpack_public_path__ + "static/media/vip-message-background.63896ae0.png";